import { AnimateContext, AnimateDirection } from '@src/contexts';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { getQueryParam } from '../../../../pe-core-frontend/src/lib';
/**
 * Custom hook that provides a function to navigate back to a specified path.
 * Uses the `useNavigate` hook from React Router and the `AnimateContext` for animation.
 * This function shows a left-to-right animation when navigating back to the specified path.
 *
 * @returns {Function} The `backTo` function that can be used to navigate back to a specified path.
 */
export const useBackTo = ({ useQueryPath = true } = { useQueryPath: true }) => {
    const navigate = useNavigate();
    const { setAnimateDirection } = useContext(AnimateContext);
    /**
     * Navigates back to the specified path.
     *
     * @param {string} path - The path to navigate back to.
     */
    const backTo = (path) => {
        setAnimateDirection(AnimateDirection.LTR);
        const returnTo = (useQueryPath && getQueryParam('returnTo')) || path;
        // give some time for the animation to use the correct direction
        setTimeout(() => navigate(returnTo), 10);
    };
    return backTo;
};
